<script lang="ts">
  import { page } from '$app/stores';
  import { onMount } from 'svelte';

  $: ({ layoutConfigStore } = $page.data);
  $: activeLayoutConfig = layoutConfigStore?.activeLayoutConfig;

  $: value = $activeLayoutConfig?.name;

  onMount(() => {
    value = $activeLayoutConfig?.name;
  });

  function handleInput(e: Event) {
    const target = e.target as HTMLSelectElement;
    if (!layoutConfigStore || !$activeLayoutConfig) {
      // console.error('no layout config');
      return;
    }
    if (target.value)
      layoutConfigStore.replaceOne($activeLayoutConfig?.name, {
        ...$activeLayoutConfig,
        name: target.value
      });
    else target.value = $activeLayoutConfig?.name;
  }
</script>

<div>
  <label
    for="layoutName"
    class="block text-sm font-medium leading-6 text-gray-900">Layout Name</label
  >
  <div class="mt-2">
    <input
      value={$activeLayoutConfig?.name}
      on:blur={handleInput}
      type="text"
      name="layoutName"
      id="layoutName"
      class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
    />
  </div>
</div>
